const config = {
  regions: "europe-west3",
  functions: {
    signup: "signup",
  },
};

module.exports = config;
